/* 検索項目 テキストボックス */
import React, { memo } from 'react';

interface Props {
  name: string;
  label: string;
  value: string;
  valid_message?: Array<string>;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  max_length?: number;
  placeholder?: string;
  handleBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInput: React.FC<Props> = ({
  name,
  label,
  value,
  valid_message,
  handleChange,
  max_length,
  placeholder,
  handleBlur,
}) => {
  return (
    <div className="col-md-4">
      <span className="search-criteria-head">{label}</span>
      <div className="search-form-input-large">
        <input
          type="text"
          className="search-form-input-large"
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          maxLength={max_length}
          onBlur={handleBlur}
        />
        {valid_message && (
          <span className="is-invalid">
            <strong>{valid_message[0]}</strong>
          </span>
        )}
      </div>
    </div>
  );
};

export default memo(SearchInput);
